import {useCustomerContext} from '../../lib/context/customerContext';

// Declarative hide/show by permission. Pass a single `code`, or an array of
// codes via `any` (renders if the user holds at least one). While
// feature_rbac is off, hasPermission/hasAnyPermission both return true, so
// this renders children unconditionally during rollout.
export const Can = ({code, any, fallback = null, children}) => {
  const {hasPermission, hasAnyPermission} = useCustomerContext();
  const allowed = any ? hasAnyPermission(any) : hasPermission(code);
  return allowed ? children : fallback;
};

export default Can;
